<mat-card class="text-center mb-24">
  <mat-card-content class="box-padding">
    <div class="mat-headline-4 mb-24">{{planName}}</div>
    <div class="star-box mb-24">
      @for (item of stars; track item) {
        <img src="../../../assets/images/star-rate.svg" i18n-alt="@@starFilled" alt="Filled star">
      }
      @for (item of grayStars; track item) {
        <img src="../../../assets/images/star-rate-gray.svg" i18n-alt="@@starEmpty" alt="Empty star">
      }
    </div>
    <div class="mb-24">
      <div class="d-inline mat-heading">€{{totalPrice}}</div>
      <div i18n="@@annualFee" class="d-inline mat-caption">/Annual Fee</div>
    </div>
    <div class="mat-heading subscription-color mb-24">{{subscriptionsNumber}} <span i18n="@@subscribtions">Subscriptions</span></div>
    <div class="mat-caption">
      <span i18n="@@getExtraSubscription">Get 1 extra subscription for just</span>
      <span class="subscription-color"> € {{subscriptionsPrice}}</span>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="text-center">
  <mat-card-content>
    <div i18n="@@payWithPayPal" class="mat-headline-4 mb-24">Pay With PayPal</div>
    <div i18n="@@directToSecurePaypal" class="mat-caption mb-24">You will be directed to the secure PayPal payments screens.</div>
    <div data-testid="paypal_button" class="w-100" id="paypal-checkout-btn"></div>
    <button i18n="@@buyWithCard" data-testid="paypal_button" class="w-100 mr-16" mat-raised-button color="accent" (click)="buyWithCard()">Buy with card</button>
  </mat-card-content>
</mat-card>
